import ReactGA from 'react-ga4';
import { BaseProvider } from './baseProvider';

export class GoogleAnalyticsProvider extends BaseProvider {
  constructor(config = {}) {
    super(config);
    this.measurementId = config.measurementId;
    this.sampleRate = config.sampleRate || 1.0;
    this.anonymizeIp = config.anonymizeIp === true;
    this.respectDoNotTrack = config.respectDoNotTrack === true;
  }

  async initialize() {
    if (this.initialized) return;

    if (!this.measurementId) {
      throw new Error('Google Analytics Measurement ID is required');
    }

    try {
      ReactGA.initialize(this.measurementId, {
        gaOptions: {
          sampleRate: this.sampleRate,
          anonymizeIp: this.anonymizeIp,
          allowAdFeatures: !this.respectDoNotTrack
        }
      });
      this.initialized = true;
      
      if (this.debug) {
        console.log('[GoogleAnalytics] Initialized successfully with settings:', {
          anonymizeIp: this.anonymizeIp,
          respectDoNotTrack: this.respectDoNotTrack
        });
      }
    } catch (error) {
      console.error('[GoogleAnalytics] Initialization failed:', error);
      throw error;
    }
  }

  async track(eventName, eventData = {}) {
    if (!this.initialized) {
      this.queueEvent(eventName, eventData);
      return;
    }

    try {
      ReactGA.event({
        category: eventData.category || 'General',
        action: eventName,
        label: eventData.label,
        value: eventData.value,
        nonInteraction: eventData.nonInteraction || false,
        ...eventData
      });

      if (this.debug) {
        console.log('[GoogleAnalytics] Tracked event:', eventName, eventData);
      }
    } catch (error) {
      console.error('[GoogleAnalytics] Failed to track event:', error);
      this.queueEvent(eventName, eventData);
    }
  }

  async trackBatch(events) {
    if (!this.initialized) {
      await this.initialize();
    }

    for (const event of events) {
      await this.track(event.name, event.data);
    }
  }

  async trackPage(path) {
    if (!this.initialized) {
      await this.initialize();
    }

    try {
      ReactGA.send({ hitType: "pageview", page: path });
      
      if (this.debug) {
        console.log('[GoogleAnalytics] Tracked page view:', path);
      }
    } catch (error) {
      console.error('[GoogleAnalytics] Failed to track page view:', error);
    }
  }
} 